export type ListModifierClick = {
  shiftKey: boolean;
  ctrlKey: boolean;
  metaKey: boolean;
};

export function nextListSelection<T extends string | number>(options: {
  visibleIds: T[];
  selectedIds: T[];
  clickedId: T;
  anchorId: T | null;
  modifiers: ListModifierClick;
}): { selectedIds: T[]; anchorId: T } {
  const { visibleIds, selectedIds, clickedId, anchorId, modifiers } = options;
  const additive = modifiers.ctrlKey || modifiers.metaKey;
  if (modifiers.shiftKey) {
    const startId = anchorId != null && visibleIds.includes(anchorId) ? anchorId : clickedId;
    const start = visibleIds.indexOf(startId);
    const end = visibleIds.indexOf(clickedId);
    if (start < 0 || end < 0) {
      return { selectedIds: [clickedId], anchorId: clickedId };
    }
    const from = Math.min(start, end);
    const to = Math.max(start, end);
    const range = visibleIds.slice(from, to + 1);
    if (additive) {
      const set = new Set(selectedIds);
      for (const id of range) set.add(id);
      return {
        selectedIds: visibleIds.filter((id) => set.has(id)),
        anchorId: startId,
      };
    }
    return { selectedIds: range, anchorId: startId };
  }
  if (additive) {
    const set = new Set(selectedIds);
    if (set.has(clickedId)) set.delete(clickedId);
    else set.add(clickedId);
    return {
      selectedIds: visibleIds.filter((id) => set.has(id)),
      anchorId: clickedId,
    };
  }
  return { selectedIds: [clickedId], anchorId: clickedId };
}
